import CheckIcon from '@mui/icons-material/Check';
import { get } from 'lodash';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Chip from '@zenbusiness/zui/Chip';
import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import { useProductPrice } from '#client/pages/ProductLanding/hooks/useProductPrice';

import * as Styled from './Package.styles';
import { getDisplayPrice } from '../BuyBox/TitleSection';

const Package = ({ plan }) => {
  const theme = useTheme();
  const { amount, interval } = useProductPrice(plan.service);

  const displayPrice = getDisplayPrice(amount, interval);

  return (
    <Styled.DialogCard key={plan.name}>
      <Styled.CardTop horizontal gap={2} alignItems="center">
        {plan.icon && (
          <Styled.IconContainer color={plan.icon?.bgColor || 'default'}>
            <SharedAsset
              alt="plan icon"
              src={plan.icon.src}
              width={24}
              height={24}
              color={plan.icon.color || 'transparent'}
            />
          </Styled.IconContainer>
        )}
        <Stack gap={0.5} width="100%">
          <Styled.CardTitle>
            <Heading size="xl"><FormattedMessage id={plan.name} /></Heading>
            {plan.tag && (
              <Chip
                sx={{
                  width: 'fit-content',
                  backgroundColor: plan.tag ? get(theme, plan.tag.color) : 'transparent'
                }}
                size="small"
              >
                <FormattedMessage id={plan.tag.label} />
              </Chip>
            )}
          </Styled.CardTitle>
          {displayPrice && (
            <Text size="sm">
              {displayPrice}
            </Text>
          )}
        </Stack>
      </Styled.CardTop>
      <Stack>
        {plan.features.map((feature) => (
          <Styled.Item key={feature}>
            <CheckIcon color="success" sx={{ fontSize: 20 }} />
            <Text size="sm">
              <FormattedMessage id={feature} />
            </Text>
          </Styled.Item>
        ))}
        {plan.disabledFeatures?.map((feature) => (
          <Styled.Item key={feature}>
            <CheckIcon color="disabled" sx={{ fontSize: 20 }} />
            <Text
              color="disabled"
              size="sm"
              sx={{ textDecoration: 'line-through' }}
            >
              <FormattedMessage id={feature} />
            </Text>
          </Styled.Item>
        ))}
      </Stack>
    </Styled.DialogCard>
  );
};

Package.propTypes = {
  plan: PropTypes.shape({
    name: PropTypes.string.isRequired,
    service: PropTypes.string,
    icon: PropTypes.shape({
      src: PropTypes.string,
      bgColor: PropTypes.string,
      color: PropTypes.string
    }),
    tag: PropTypes.shape({
      label: PropTypes.string.isRequired,
      color: PropTypes.string
    }),
    features: PropTypes.arrayOf(PropTypes.string).isRequired,
    disabledFeatures: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};

export default Package;
